import React, { useEffect, useRef,useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
const groupMessagesByDate = (messages) => {
  return messages.reduce((groups, message) => {
      const date = message.modifiedDate;
      if (!groups[date]) {
          groups[date] = [];
      }
      groups[date].push(message);
      return groups;
  }, {});
};
function convertTo12HourFormat(timeString) {
  // Split the input string to get hours, minutes, and seconds
  const [hours, minutes] = timeString.split(':').map(Number);

  // Determine AM or PM suffix
  const suffix = hours >= 12 ? 'PM' : 'AM';

  // Convert hours from 24-hour to 12-hour format
  const hourIn12HrFormat = hours % 12 || 12; // Use 12 for midnight and noon

  // Return formatted time string
  return `${hourIn12HrFormat}:${minutes.toString().padStart(2, '0')} ${suffix}`;
}

const ConversationList = ({smsData,handleSendMessage,getConversationDetails,conversationDetailsLoading,conversationDetails}) => {
  const groupedMessages = groupMessagesByDate(smsData);
  const dates = Object.keys(groupedMessages);

  const [charCount,setCharCount] = useState(0)
  const [message, setMessage] = useState('');
  const messagesEndRef = useRef(null);
  const [maxCount,setMaxCount] = useState(false)

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    getConversationDetails()
    setShow(true);
  }
 

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleInputChange = (event) => {
    
    const inputValue = event.target.value;
    if(inputValue.length <= 450){
      setMessage(inputValue);
      setCharCount(inputValue.length);
      setMaxCount(false)
    }else{
      setMaxCount(true)
    }
   
  };
  useEffect(() => {
    scrollToBottom();
  }, [smsData]);

  const sendMessage = () => {
    if (message.trim() !== '') {
      //check confirmationrequired is checked or not if checked then add its value to be true
      const confirmationRequired = document.getElementById('confirmationrequired').checked;

      handleSendMessage(message,confirmationRequired);
      setMessage('');
      setCharCount(0);
    }
  };
 
  const TextWithLinks = ({ text }) => {
    // Regex pattern to detect URLs in the text
    const urlPattern = /(https?:\/\/[^\s]+)/g;
  
    // Split the text based on URLs and create clickable links
    /*
      onClick={(e) => {
              e.preventDefault();
              window.open(part, '_blank');
            }}
    */
    const parts = text.split(urlPattern).map((part, index) => {
      if (urlPattern.test(part)) {
        return (
          <Link
            key={index}
            to="#"
          
            style={{ color: 'blue', textDecoration: 'underline' }}
          >
            {part}
          </Link>
        );
      } else {
        return part;
      }
    });
  
    return <>{parts}</>;
  };
  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
                 
                <div className='d-flex flex-row align-items-center'>
                   <div className="symbol symbol-45px symbol-circle me-2" zn_id="155">
                        <span className="symbol-label bg-light-primary  fs-6 fw-bolder" zn_id="157">{smsData[0].customerFirstName.trim().charAt(0).toUpperCase()}</span>
                   </div>
                   <div>
                   <div className="text-gray-800 fw-bold fs-6 mt-4">{smsData[0].customerFirstName} {smsData[0].customerLastName}</div>
                   <p className='text-muted'>{smsData[0].customerDob && smsData[0].customerDob}</p>
                   </div>
              
                </div>

                <div className='text-gray-900'>
                  <button className="btn btn-sm btn-light-primary mt-4 " onClick={handleShow}> <i className="bi bi-three-dots"></i> </button>
                </div>
                
               
            </div>
            <div className="card-body bg-light" style={{height: '55vh',  overflowY: 'scroll' }}>
             
            <div className="d-flex flex-column">

            {dates.map(date => (
                <div key={date} >
                    <div className='d-flex justify-content-center p-1 rounded bg-secondary mb-4'>
                       <span className='text-muted'>{date}</span>
                    </div>
                   
                    {groupedMessages[date].map((message, index) => (
                        <div
                        key={index}
                        className={`d-flex ${message.messageType === 'OUTGOING' ? 'justify-content-end' : 'justify-content-start'}`}
                      >
                        <div
                          className={`mb-4 ps-4 pe-2 pt-2 rounded ${
                            message.messageType === 'OUTGOING' ? 'bg-light-primary' : 'bg-secondary text-dark'
                          }`}
                          style={{ maxWidth: '75%' }}
                        >
                          <TextWithLinks text={message.message} /> {message.messageType ==='OUTGOING'? message.status ==="DELIVERED"? <i className="bi bi-check-all"></i> : <i className="bi.bi-exclamation-circle"></i> :"" }
                          <p className={`fs-7 mt-2 ${ message.messageType === 'OUTGOING' ? 'text-muted':'text-muted'}`}> {convertTo12HourFormat(message.modifiedTime)}</p>
                        </div>
                      </div>
                    ))}
                </div>
            ))}
           
               </div>
              <div ref={messagesEndRef} />
            </div>
          </div>
          <div className="input-group mt-3">
          
            {/* Text area */}
            <textarea className="form-control" rows="2" value={message} onChange={handleInputChange} placeholder="Type a message" zn_id="1"></textarea>
            <button className="btn btn-primary" onClick={sendMessage} >Send</button>
          </div>
          {/* Message Character count */}
          {maxCount && <div className="text-danger ms-3">You have reached the maximum limit of 450 characters.</div>}
          <div className="text-muted d-flex justify-content-between">
              
              
          
          <div className='form-check mt-2'>
                    <input type="checkbox" name="confirmationrequired" id="confirmationrequired" className="form-check-input" />
                    <label className="form-check-label">Confimation Required</label>
               </div>
               <div className='me-4'>{charCount}/450</div>
               </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Details for {smsData[0].customer}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
              <ul className='list-group rounded'>
              {
                conversationDetailsLoading ? <div>Loading...</div> : <>
                 {conversationDetails && conversationDetails.map((message, index) => (
                  <li key={index} className='list-group-item list-group-item-action d-flex justify-content-between'>
                      <div className="d-flex flex-column">
                        <div className='fw-bold'>{message.firstName} {message.lastName}</div>
                        <div>{message.customerId}</div>
                        
                      </div>
                      <div>{message.customerDob}</div>
                  </li>
                ))}
                </>
                }
            </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ConversationList;
